// extracted by mini-css-extract-plugin
module.exports = {"loaderScreen":"loaderScreen_loaderScreen__hmehJ","loaderText":"loaderScreen_loaderText__8eTI_"};